import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Dots from "react-activity/lib/Dots";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import plane from "../images/plane_icon2.png";
import { getMainImage } from "../services/aircraftImageService";
import { getAircraftDetail } from "../services/aircraftDetailService";
import { getCurrentUser } from "../services/authService";

class AircraftDetails extends Component {
  state = {
    image: "",
    aircraftDetails: [],
    user: {},
    loaded: true,
    link: "",
  };

  async componentDidMount() {
    this.setState({ loaded: false });
    const user = getCurrentUser();

    const items = this.props.location.pathname.split("/");
    const aircraft_id = items[3];

    const aircraftDetails = await getAircraftDetail(aircraft_id);

    const image = await getMainImage(aircraft_id);

    let link = "";
    if (aircraftDetails[0].wikilink === "") {
    } else {
      if (aircraftDetails[0].wikilink.startsWith("http"))
        link = aircraftDetails[0].wikilink;
      else link = `//${aircraftDetails[0].wikilink}`;
    }

    if (image === null)
      this.setState({ aircraftDetails, user, loaded: true, link });
    else
      this.setState({
        aircraftDetails,
        image: image.aircraft_image,
        user,
        loaded: true,
        link,
      });
  }

  handleEditAircraft(aircraft_id) {
    this.props.history.push({ pathname: `/aircraft/edit/${aircraft_id}` });
  }

  handleEditModels(aircraft_id) {
    this.props.history.push("/models", { params: aircraft_id });
  }

  handleShowManufacturer(manufacturer_id) {
    this.props.history.push(`/manufacturer/details/${manufacturer_id}`);
  }

  handleShowResults = () => {
    this.props.history.push("/aircraft/results");
  };

  render() {
    const { image, aircraftDetails, user, loaded, link } = this.state;

    let img = "";
    let wiki;
    if (loaded) {
      if (aircraftDetails.length === 0) {
        return null;
      }
      if (image) img = "data:image/png;base64," + image;
      else img = plane;

      if (link.length > 0)
        wiki = (
          <a href={link} target="_blank" rel="noreferrer">
            Wikipedia
          </a>
        );
    }

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div className="row">
          <div className="col-9" style={{ backgroundColor: "white" }}>
            {user && (
              <h3>
                <FontAwesomeIcon icon="plane" />
                &nbsp;
                <Button
                  variant="link"
                  size="lg"
                  onClick={() =>
                    this.handleEditAircraft(aircraftDetails[0].aircraft_id)
                  }
                >
                  EDIT - {aircraftDetails[0].aircraft_name}
                </Button>
              </h3>
            )}
            {!user && (
              <h3>
                <FontAwesomeIcon icon="plane" />
                {aircraftDetails[0].aircraft_name}
              </h3>
            )}
          </div>
          <div
            className="col-3"
            style={{ backgroundColor: "white", textAlign: "right" }}
          >
            <Button variant="link" onClick={() => this.handleShowResults()}>
              <FontAwesomeIcon icon="list" />
              &nbsp; Search Results
            </Button>
          </div>
        </div>

        <div className="row" style={{ marginTop: 10 }}>
          <div
            className="col"
            style={{
              backgroundColor: "white",
              textAlign: "center",
              paddingTop: "12px",
              border: "2px solid #dee2e6",
            }}
          >
            <img
              src={img}
              alt="plane.jpeg"
              className="aircraftDetailsPhoto"
            ></img>
            <div>{wiki}</div>
          </div>
          <div
            className="col"
            style={{
              backgroundColor: "white",
              border: "2px solid #dee2e6",
              marginLeft: "10px",
            }}
          >
            <table className="aircraftdetails">
              <tbody>
                <tr key="year">
                  <td>
                    <FontAwesomeIcon icon="calendar-alt" />
                    &nbsp; Year of Manufacture
                  </td>
                </tr>
                <tr>
                  <td className="detailBold">
                    {aircraftDetails[0].year_of_manufacture}
                  </td>
                </tr>
                <tr key="country">
                  <td>
                    <FontAwesomeIcon icon="flag-usa" />
                    &nbsp; Country of Manufacturer
                  </td>
                </tr>
                <tr>
                  <td className="detailBold">
                    {aircraftDetails[0].country_of_manufacturer}
                  </td>
                </tr>
                <tr key="operators">
                  <td>
                    <FontAwesomeIcon icon="user-friends" />
                    &nbsp; Operators during WWII
                  </td>
                </tr>
                <tr>
                  <td className="detailBold">
                    {aircraftDetails[0].operators_during_wwii}
                  </td>
                </tr>
                <tr key="group">
                  <td>
                    <FontAwesomeIcon icon="plane" />
                    &nbsp; Primary group
                  </td>
                </tr>
                <tr>
                  <td className="detailBold">
                    {aircraftDetails[0].group_name}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ textAlign: "left", marginTop: 60 }}>
          {user && (
            <h5>
              Brand Models &nbsp;
              <Button
                variant="link"
                onClick={() =>
                  this.handleEditModels(aircraftDetails[0].aircraft_id)
                }
              >
                <FontAwesomeIcon icon="pencil-alt" />
                &nbsp; Edit Models
              </Button>
            </h5>
          )}
          {!user && <h5>Brand Models</h5>}
          <table className="myTable modelsTable">
            <thead>
              <tr key="heading">
                <th>
                  <FontAwesomeIcon icon="tools" />
                  &nbsp; Brand
                </th>
                <th>
                  <FontAwesomeIcon icon="flag-usa" />
                  &nbsp; Country of Origin
                </th>
                <th>
                  <FontAwesomeIcon icon="dna" />
                  &nbsp; Media
                </th>
                <th>
                  <FontAwesomeIcon icon="balance-scale-right" />
                  &nbsp; Scale Range
                </th>
                <th>
                  <FontAwesomeIcon icon="hard-hat" />
                  &nbsp; Kit Mold
                </th>
                <th>
                  <FontAwesomeIcon icon="hashtag" />
                  &nbsp; Kit No.
                </th>
              </tr>
            </thead>
            <tbody>
              {aircraftDetails.map((detail) => (
                <tr key={detail.id}>
                  <td>
                    <Button
                      variant="link"
                      id="brand_link"
                      onClick={() =>
                        this.handleShowManufacturer(detail.manufacturer_id)
                      }
                    >
                      {detail.manufacturer_fullname}
                    </Button>
                  </td>
                  <td>{detail.country_of_origin}</td>
                  <td>{detail.media_name}</td>
                  <td>{detail.scale_range}</td>
                  <td>{detail.kit_mold}</td>
                  <td>{detail.kit_no}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr key="footer">
                <td colspan="6"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(AircraftDetails);
